import { render, staticRenderFns } from "./deduct_type.vue?vue&type=template&id=b5c3d1ba&scoped=true"
import script from "./deduct_type.vue?vue&type=script&lang=js"
export * from "./deduct_type.vue?vue&type=script&lang=js"
import style0 from "./deduct_type.vue?vue&type=style&index=0&id=b5c3d1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c3d1ba",
  null
  
)

export default component.exports